import { instance } from "libs/api";

import { ApiRoutesNotifications } from "../../constants";
import { CreateNotificationBody } from "./createNotification.types";

export const requestCreateNotification = async (
  body: CreateNotificationBody
): Promise<void> => {
  return await instance.post(ApiRoutesNotifications.Notifications, body);
};
